module.exports = __webpack_public_path__ + "files/0868c2f16239ad64fef6d0a76c59f746.png";